import React from "react";
import MainPart from "./MainPart";
import { Select, MenuItem, Typography, Box, Avatar } from "@mui/material";
import { get_app_logo, s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { show_proper_words } from "src/utils/constants";

export default function MobilesTabs({
  showInfoBox,
  setShowInfoBox,
  userInfo,
  handleMyPosts,
  data,
  name_group,
}) {
  const { selectedGroup, setSelectedGroup } = useContentSetting();

  const handleGroupFeed = (value) => {
    localStorage.setItem("selectedGroup", value || "general");
    setSelectedGroup(value || "");
  };

  const logo = get_app_logo();
  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <h2>
            {name_group?.title
              ? show_proper_words(name_group.title)
              : "General Community"}
          </h2>
        </div>
        <div className="col-lg-6 col-sm-12 text-end mb-2">
          <button className="small-contained-button" onClick={handleMyPosts}>
            My Posts
          </button>
        </div>
      </div>
      <Box sx={{ width: "100%" }}>
        <Select
          fullWidth
          value={selectedGroup || ""}
          onChange={(e) => handleGroupFeed(e.target.value)}
          displayEmpty
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar
                    src={logo}
                    alt="General Group"
                    sx={{ width: 32, height: 32 }}
                    variant="rounded"
                  />
                  General Community
                </Box>
              );
            }
            const group = data?.find((g) => g._id === selected);
            return (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar
                  src={group ? s3baseUrl + group.image.thumbnail_1 : ""}
                  alt={group ? group.title : ""}
                  sx={{ width: 32, height: 32 }}
                  variant="rounded"
                />
                {group ? group.title : "General Community"}
              </Box>
            );
          }}
        >
          <MenuItem value="">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                src={logo}
                alt="General Group"
                sx={{ width: 32, height: 32 }}
                variant="rounded"
              />
              General Community
            </Box>
          </MenuItem>
          {data &&
            data.length > 0 &&
            data.map((item) => (
              <MenuItem key={item._id} value={item._id}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar
                    src={s3baseUrl + item.image.thumbnail_1}
                    alt={item.title}
                    sx={{ width: 32, height: 32 }}
                    variant="rounded"
                  />
                  {item.title}
                </Box>
              </MenuItem>
            ))}
        </Select>
      </Box>
      <MainPart
        showInfoBox={showInfoBox}
        setShowInfoBox={setShowInfoBox}
        userInfo={userInfo}
        event_id=""
      />
    </>
  );
}
